const GraphSkeleton = () => <div className="w-full h-[240px] bg-dark animate-pulse rounded-lg" />;

export default GraphSkeleton;
